import {
  getFileExtension,
  hasExtension,
} from '@frameio/utils/files/fileExtensionHelpers';

/**
 * Ensures all file names have file extensions by extracting them from corresponding file paths.
 *
 * @param params - Object containing fileNames and filePaths arrays
 * @param params.fileNames - Array of file names that may or may not have extensions
 * @param params.filePaths - Array of complete file paths with extensions, corresponding by index to fileNames
 * @returns Array of file names with extensions guaranteed to be present
 *
 * @example
 * ensureFileNamesHaveExtensions({ fileNames: ['video'], filePaths: ['/path/video.mp4'] }) // Returns: ['video.mp4']
 */
export function ensureFileNamesHaveExtensions({
  fileNames,
  filePaths,
}: {
  fileNames: string[];
  filePaths: string[];
}): string[] {
  return fileNames.map((fileName, index) => {
    if (hasExtension(fileName)) {
      return fileName;
    }
    return `${fileName}.${getFileExtension(filePaths[index])}`;
  });
}
